import {analysisStartedMessageHandler} from 'notebook/realtime/messageHandlers/analysisStartedMessageHandler';
import {
  DocumentUpdateMessageHandler,
  MessageHandlersByType,
} from 'notebook/realtime/messageHandlers/DocumentUpdateMessageHandlerConstants';
import {entryUpdateMessageHandler} from 'notebook/realtime/messageHandlers/entryUpdateMessageHandler';
import {lockUpdateMessageHandler} from 'notebook/realtime/messageHandlers/lockUpdateMessageHandler';
import {tableApiPendingRowsUpdateMessageHandler} from 'notebook/realtime/messageHandlers/tableApiPendingRowsUpdateMessageHandler';
import {RealtimeMessageType} from 'realtime/Constants';
import {RealtimeMessage} from 'realtime/RealtimeChannel';

// Mapped object that preserves the specific type for each handler
const messageHandlers: MessageHandlersByType = {
  [RealtimeMessageType.ENTRY_UPDATE]: entryUpdateMessageHandler,
  [RealtimeMessageType.LOCK_UPDATE]: lockUpdateMessageHandler,
  [RealtimeMessageType.TABLE_API_PENDING_ROWS_UPDATE]: tableApiPendingRowsUpdateMessageHandler,
  [RealtimeMessageType.ANALYSIS_STARTED]: analysisStartedMessageHandler,
};

/**
 * Maps a message to its handler.
 */
export function messageRouter(fileId: string, type: 'active' | 'inactive'): (msg: RealtimeMessage) => void {
  return ({name, data}) => {
    const handler = getMessageHandler(name);
    if (handler[type]) {
      handler[type](fileId, data ?? {});
    }
  };
}

function getMessageHandler<T extends RealtimeMessageType>(type: T): DocumentUpdateMessageHandler<T> {
  // The mapped object ensures type safety - each handler is correctly typed for its message
  // Some messages are filtered out by this channel listener, so we return an empty object as fallback
  return messageHandlers[type] ?? {};
}
